import React, { useEffect, useState } from "react";
import {
  Typography, Box, Card, CardContent, CardActions, Avatar,
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
  TextField, List, ListItem, ListItemText, Select, MenuItem, InputLabel,
  FormControl, CircularProgress, Tooltip
} from "@mui/material";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { postDossierActionPlan, deleteActionPlan, getDossierActionPlan, getDossierTagUsersList, markActionPlanDone} from "../Dossier/Network_call";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
 
const ActionPlan = ({ dossierData }) => {
  const [message, setMessage] = useState("");
  const [actionPlans, setActionPlans] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [open, setOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [showUserList, setShowUserList] = useState(false);
  const [taggedList, setTaggedList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showAllActionPlans, setShowAllActionPlans] = useState(false);
 console.log("PPPPP", dossierData);
  let dossierId = dossierData?.id;
  let Customer_External_id = dossierData?.external_id;
  let impl_id = localStorage.getItem('tag_id');

 
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const actionPlanResult = await getDossierActionPlan(dossierId);
        if (actionPlanResult.status === 200) {
          let data = actionPlanResult.data;
          if (data.error !== "Dossier Action Plan not found") {
            setActionPlans(data.actionPlans);
          }
        } else {
          console.error("Error fetching dossier Action Plan details");
        }
 
        const customerResp = await getDossierTagUsersList(impl_id);
        setUsers(customerResp.data.userListRows);

      } catch (error) {
        console.error("Failed to fetch data", error);
        toast.error("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };
 
    fetchData();
  }, [dossierId]);


  useEffect(() => {

    const updateTaggedList = () => {
        const newTaggedList = users
            .filter(user => {
                const usernameToMatch = user.name.startsWith('$') ? user.email.split('@')[0] : user.name;
                return message.includes(`@${usernameToMatch}`);
            })
            .map(user => {
                const username = user.name.startsWith('$')
                    ? user.email.split('@')[0]  
                    : user.name;

                return {
                    username: username,
                    user_id: user.id,
                };
            });

        setTaggedList(newTaggedList);
    };

    updateTaggedList();
}, [message, users]);

 
  const handleOpen = () => {
    setMessage("");
    setEditIndex(null);
    setOpen(true);
    setTaggedList([]);
    setSelectedUser(null);
  };
 
  const handleClose = () => {
    setOpen(false);
  };
 
  const extractPlainText = (text, taggedList) => {
    let cleanText = text;
    taggedList.forEach(tag => {
      
      const regex = new RegExp(`@${tag.username}`, 'g');
      cleanText = cleanText.replace(regex, '').trim();
    });

    return cleanText;
  };
 
const handleSave = async () => {
  if (message.trim()) {
    const cleanMessage = extractPlainText(message, taggedList);

    const formattedTaggedList = taggedList.map((tag) => ({
      id:
        actionPlans[editIndex]?.tagged_list?.find(
          (t) => t.username === tag.username
        )?.id || undefined,
      username: tag.username,
      user_id: tag.user_id,
    }));

    let updatedPlan = {
      plan: cleanMessage,
      tagged_list: formattedTaggedList,
    };

    if (editIndex !== null && actionPlans[editIndex]) {
      updatedPlan.id = actionPlans[editIndex].id;
    }
    console.log("PPPPPP", dossierId)
    try {
      const result = await postDossierActionPlan(
        [updatedPlan],
        dossierId,
        Customer_External_id
      );
      if (result.status === 200) {
        fetchUpdatedActionPlans();
        toast.success("Dossier details submitted successfully");
      } else {
        toast.error("Failed to submit dossier details");
      }
    } catch (error) {
      toast.error("An error occurred while submitting the dossier details");
    }

    handleClose();
  } else {
    toast.error("Message cannot be empty");
  }
};
const fetchUpdatedActionPlans = async () => {
  try {
    const actionPlanResult = await getDossierActionPlan(dossierId);
    if (actionPlanResult.status === 200 && actionPlanResult.data?.actionPlans) {
      setActionPlans(actionPlanResult.data.actionPlans);
    }
  } catch (error) {
    console.error("Error fetching updated dossier action plans", error);
  }
};


  const handleEdit = (index) => {
  const plan = actionPlans[index];


  const combinedMessage =
    plan.plan +
    " " +
    (plan.tagged_list
      ? plan.tagged_list.map((tag) => `@${tag.username}`).join(" ")
      : "");

  setMessage(combinedMessage.trim());
  setTaggedList(plan.tagged_list );
  setEditIndex(index);
  setTimeout(() => setOpen(true), 0);
};

  useEffect(() => {
    if (open && editIndex !== null) {
      const plan = actionPlans[editIndex];
      setTaggedList(plan?.tagged_list || []);
    }
  }, [open, editIndex, actionPlans]);
 
  const handleDelete = async(index) => {
    try {
      const result = await deleteActionPlan(index);
     
      if (result.status === 200) {
        toast.success("Dossier Action Plan deleted successfully");
        setActionPlans((prevActionPlans) =>
          prevActionPlans.filter((plan) => plan.id !== index)
        );
      } else {
        toast.error("Failed to delete dossier action plan");
      }
    } catch (error) {
      toast.error("An error occurred while deleting the dossier action plans");
    }
  };

  const handleMarkDone = async (id) => {
    try {
      const result = await markActionPlanDone(id);

      if (result.status === 200) {
        toast.success("Action Plan marked as done");

       setActionPlans((prevActionPlans) =>
        prevActionPlans.map((plan) =>
          plan.id === id
            ? {
                ...plan,
                status: "DONE",
                completed_at:
                  result.data?.actionPlan?.completed_at ||
                  new Date().toISOString(),
              }
            : plan
        )
      );
      } else {
        toast.error("Failed to mark Action Plan as done");
      }
    } catch (error) {
      console.error(
        "Error marking Action Plan as done:",
        error
      );

      toast.error(
        "An error occurred while marking Action Plan as done"
      );
    }
  };
 
  const handleChange = (e) => {
    const value = e.target.value;
    setMessage(value);
 
    if (value.includes('@')) {
      setShowUserList(true);
      const inputAfterAt = value.split('@').pop();
      const filtered = users.filter(user => user.name.toLowerCase().includes(inputAfterAt.toLowerCase()));
      setFilteredUsers(filtered);
    } else {
      setShowUserList(false);
    }
  };
 
  const handleUserClick = (user) => {
    if (!taggedList.some(tag => tag.user_id === user.id)) {
      setMessage(message.replace(/@\w*$/, `@${user.name}`));
      setTaggedList([...taggedList, { username: user.name, user_id: user.id }]);
    }
    setFilteredUsers([]);
    setShowUserList(false);
  };
  
  const handleUserSelect = (event) => {
    const selectedUserId = event.target.value;
    const user = users.find(user => user.id === selectedUserId);
    if (user) {

      const username = user.name.startsWith('$')
      ? user.email.split('@')[0]  
      : user.name;
      
      const formattedUsername = `${username}`;
      const isAlreadyTagged = taggedList.some(tag => tag.user_id === user.id);

      
      if (!isAlreadyTagged) {
        setMessage(`${message} @${formattedUsername}`);

        setTaggedList([...taggedList, { username: formattedUsername, user_id: user.id }]);
       
      }
      
      setSelectedUser(null);
      setShowUserList(false);
    }
  };
  
  const handleTagRemove = (user_id) => {
    setTaggedList(taggedList.filter(tag => tag.user_id !== user_id));
    setMessage(message.replace(new RegExp(`@${taggedList.find(tag => tag.user_id === user_id).username}`, 'g'), ''));
  };
 
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: 'numeric', month: 'short', year: 'numeric' };
    const formattedDate = date.toLocaleDateString('en-GB', options);
 
    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);
   
    let timeAgo;
    if (seconds < 60) {
      timeAgo = `${seconds} second${seconds === 1 ? '' : 's'} ago`;
    } else if (seconds < 3600) {
      const minutes = Math.floor(seconds / 60);
      timeAgo = `${minutes} minute${minutes === 1 ? '' : 's'} ago`;
    } else if (seconds < 86400) {
      const hours = Math.floor(seconds / 3600);
      timeAgo = `${hours} hour${hours === 1 ? '' : 's'} ago`;
    } else if (seconds < 2592000) {
      const days = Math.floor(seconds / 86400);
      timeAgo = `${days} day${days === 1 ? '' : 's'} ago`;
    } else if (seconds < 31536000) {
      const months = Math.floor(seconds / 2592000);
      timeAgo = `${months} month${months === 1 ? '' : 's'} ago`;
    } else {
      const years = Math.floor(seconds / 31536000);
      timeAgo = `${years} year${years === 1 ? '' : 's'} ago`;
    }
   return {
      formattedDate,
      timeAgo,
    };
  };

  const renderDate = (date) => {
    if (!date) return "-";

    const dateInfo = formatDate(date);

    return (
      <Box>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 600,
            color: "#374151",
            lineHeight: 1.4,
          }}
        >
          {dateInfo.formattedDate}
        </Typography>

        <Typography
          sx={{
            fontSize: "12px",
            color: "#9ca3af",
            mt: 0.3,
          }}
        >
          {dateInfo.timeAgo}
        </Typography>
      </Box>
    );
  };
  return (
    <Box sx={{
        p: 3,
        bgcolor: "#ffffff",
        height: "100%",
        overflowY: "auto",
      }}
    >
      <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold", color: "#00A0B2" }}>
        Action Plans
      </Typography>
      {loading ? (
        <CircularProgress sx={{ color: "#1FAFC2", marginLeft: "8px" }} />
      ) : (
        <>
          <Button
            variant="contained"
            onClick={handleOpen}
            sx={{ mb: 2, backgroundColor: '#1976d2', '&:hover': { backgroundColor: '#1565c0' } }}
          >
            Add Message
          </Button>
          <Box sx={{ mt: 2, width: "100%" }}>

            {actionPlans.length === 0 ? (
              <Box
                sx={{
                  py: 5,
                  textAlign: "center",
                  border: "1px solid #e5e7eb",
                  borderRadius: "10px",
                  backgroundColor: "#fafafa",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ color: "#777" }}
                >
                  No action plans found.
                </Typography>
              </Box>
            ) : (
              <Box
                sx={{
                  width: "100%",
                  overflowX: "auto",
                  border: "1px solid #e5e7eb",
                  borderRadius: "12px",
                  backgroundColor: "#fff",
                  overflow: "hidden",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                }}
              >
                <Table
                  sx={{
                    minWidth: "850px",
                    tableLayout: "fixed",
                  }}
                >
                  <TableHead>
                    <TableRow
                      sx={{
                        backgroundColor: "#f8fafc",
                        "& th": {
                          borderBottom: "1px solid #e5e7eb",
                          py: 2,
                        },
                      }}
                    >
                      <TableCell
                        sx={{
                          width: "130px",
                          fontWeight: 600,
                          color: "#444",
                          fontSize: "13px",
                          borderBottom: "1px solid #e1e5e9",
                        }}
                      >
                        Created Date
                      </TableCell>

                      <TableCell
                        sx={{
                          fontWeight: 600,
                          color: "#444",
                          fontSize: "13px",
                          borderBottom: "1px solid #e1e5e9",
                        }}
                      >
                        Action Plan
                      </TableCell>

                      <TableCell
                        sx={{
                          width: "150px",
                          fontWeight: 600,
                          color: "#444",
                          fontSize: "13px",
                          borderBottom: "1px solid #e1e5e9",
                        }}
                      >
                        Created By
                      </TableCell>

                      <TableCell
                        sx={{
                          width: "100px",
                          fontWeight: 600,
                          color: "#444",
                          fontSize: "13px",
                          borderBottom: "1px solid #e1e5e9",
                        }}
                      >
                        Status
                      </TableCell>

                      <TableCell
                        align="center"
                        sx={{
                          width: "110px",
                          fontWeight: 600,
                          color: "#444",
                          fontSize: "13px",
                          borderBottom: "1px solid #e1e5e9",
                        }}
                      >
                        Actions
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {actionPlans.map((plan, index) => (
                      <TableRow
                        key={plan.id}
                        hover
                        sx={{
                          "&:last-child td": {
                            borderBottom: 0,
                          },
                        }}
                      >

                        {/* Created Date */}
                        <TableCell
                            sx={{
                              verticalAlign: "top",
                              py: 2.2,
                            }}
                          >
                            {renderDate(plan.created_at)}
                          </TableCell>

                        {/* Action Plan */}
                        <TableCell
                          sx={{
                            verticalAlign: "top",
                            py: 2.2,
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "15px",
                              fontWeight: 500,
                              color: "#1f2937",
                              lineHeight: 1.5,
                              whiteSpace: "pre-wrap",
                              wordBreak: "break-word",
                            }}
                          >
                            {plan.plan || "-"}
                          </Typography>

                          {plan.status === "DONE" &&
                            plan.completed_at && (
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                  mt: 0.8,
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faCircleCheck}
                                  style={{
                                    color: "#2e7d32",
                                    fontSize: "13px",
                                  }}
                                />

                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    color: "#6b7280",
                                  }}
                                >
                                  Completed on{" "}
                                  {formatDate(plan.completed_at).formattedDate}
                                </Typography>
                              </Box>
                            )}
                        </TableCell>

                        {/* Created By */}
                        <TableCell
                          sx={{
                            verticalAlign: "top",
                            py: 2.2,
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            

                            <Typography
                              sx={{
                                fontSize: "14px",
                                color: "#4b5563",
                                fontWeight: 500,
                              }}
                            >
                              {plan.created_by ||
                                plan.username ||
                                "-"}
                            </Typography>
                          </Box>
                        </TableCell>

                        {/* Status */}
                        <TableCell
                          sx={{
                            verticalAlign: "top",
                            py: 2,
                          }}
                        >
                          <Box
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "6px",
                              px: 1.4,
                              py: 0.6,
                              borderRadius: "20px",
                              backgroundColor:
                                plan.status === "DONE"
                                  ? "#e8f5e9"
                                  : "#fff7ed",
                              color:
                                plan.status === "DONE"
                                  ? "#2e7d32"
                                  : "#d97706",
                              fontSize: "12px",
                              fontWeight: 700,
                            }}
                          >
                            {plan.status === "DONE" ? "✓" : "●"}

                            {plan.status || "OPEN"}
                          </Box>
                        </TableCell>

                        {/* Actions */}
                        <TableCell
                          align="center"
                          sx={{
                            verticalAlign: "top",
                            py: 2,
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "8px",
                            }}
                          >
                            {/* Edit */}
                            <Tooltip title="Edit" arrow>
                              <Box
                                onClick={() => handleEdit(index)}
                                sx={{
                                  width: 32,
                                  height: 32,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderRadius: "8px",
                                  cursor: "pointer",
                                  backgroundColor: "#f3f4f6",
                                  color: "#555",
                                  transition: "0.2s",
                                  "&:hover": {
                                    backgroundColor: "#e5e7eb",
                                  },
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faPenToSquare}
                                  fontSize="15px"
                                />
                              </Box>
                            </Tooltip>

                            {/* Delete */}
                            <Tooltip title="Delete" arrow>
                              <Box
                                onClick={() => handleDelete(plan.id)}
                                sx={{
                                  width: 32,
                                  height: 32,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderRadius: "8px",
                                  cursor: "pointer",
                                  backgroundColor: "#fef2f2",
                                  color: "#d9554c",
                                  transition: "0.2s",
                                  "&:hover": {
                                    backgroundColor: "#fee2e2",
                                  },
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faTrash}
                                  fontSize="15px"
                                />
                              </Box>
                            </Tooltip>

                            {/* Mark Done */}
                            {plan.status !== "DONE" && (
                              <Tooltip title="Mark as Done" arrow>
                                <Box
                                  onClick={() => handleMarkDone(plan.id)}
                                  sx={{
                                    width: 32,
                                    height: 32,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: "50%",
                                    cursor: "pointer",
                                    backgroundColor: "#e8f5e9",
                                    color: "#2e7d32",
                                    transition: "0.2s",
                                    "&:hover": {
                                      backgroundColor: "#c8e6c9",
                                    },
                                  }}
                                >
                                  <FontAwesomeIcon
                                    icon={faCircleCheck}
                                    fontSize="16px"
                                  />
                                </Box>
                              </Tooltip>
                            )}

                          </Box>
                        </TableCell>

                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            )}

          </Box>
        </>
      )}
 
      <Dialog open={open} onClose={handleClose} sx={{ '& .MuiDialog-paper': { width: '600px' } }}>
        <DialogTitle>{editIndex !== null ? "Edit Message" : "Add Message"}</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Message"
            variant="outlined"
            value={message}
            onChange={handleChange}
            helperText="Use '@' to tag people"
            multiline
            rows={4}
          />
          {showUserList && (
            <List>
              {filteredUsers.map(user => (
                <ListItem button key={user.id} onClick={() => handleUserClick(user)}>
                  <ListItemText primary={user.name} />
                </ListItem>
              ))}
            </List>
          )}
          <Typography variant="subtitle1" sx={{ mt: 2 }}>Select User:</Typography>
          <FormControl fullWidth>
            <InputLabel>Select User</InputLabel>
            <Select
              value={selectedUser || ''}
              onChange={handleUserSelect}
              label="Select User"
            >
              {
                users
                .filter(user => !user.email.split('@')[0].startsWith("share_"))
                .map(user => (
                  <MenuItem key={user.id} value={user.id}>
                    {user.name.startsWith('$') ? (
                      <>{user.email.split('@')[0]}</>
                    ) : (
                      <>{user.name}</>
                    )}
                  </MenuItem>
                ))
              }
            </Select>
          </FormControl>
          <Typography variant="subtitle1" sx={{ mt: 2 }}>Tagged Users:</Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {taggedList.map(tag => (
              <Button
                key={tag.user_id}
                variant="contained"
                color="primary"
                sx={{ mr: 1, width: 'fit-content' }}
                onClick={() => handleTagRemove(tag.user_id)}
              >
                {tag.username}
                
              </Button>
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSave} variant="contained" color="primary">Save</Button>
          <Button onClick={handleClose} variant="contained" color="error">Cancel</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
 
export default ActionPlan;